import * as Yup from 'yup';

export const usersSchema = Yup.object().shape({
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
    phoneNumber: Yup.string().required('Phone number is required'),
    email: Yup.string().email('Invalid email address').required('Email is required'),
});

export const usersInitialValues = (initialData) => ({
    firstName: initialData?.first_name,
    lastName: initialData?.last_name,
    email: initialData?.email,
    phoneNumber: initialData?.phone_number,
});
